import { Action, ActionKind } from './actions';
import { State } from './types';

export const initialState: State = {
  user: null,
  error: null,
  isError: false,
  isLoading: false,
  isLoggedIn: false,
};

export const authReducer = (state: State, action: Action): State => {
  const { type, payload } = action;

  switch (type) {
    case ActionKind.Login:
      return { ...initialState, isLoading: true };

    case ActionKind.Logout:
      return { ...initialState };

    case ActionKind.LoginFailed:
      return { ...initialState, isError: true, error: payload };

    case ActionKind.LoginSuccess:
      return { ...initialState, isLoggedIn: true, user: payload };

    default:
      return state;
  }
};
